import 'babel-polyfill'
import objectFitImages from 'object-fit-images'
import '@fancyapps/fancybox'
import 'jquery-match-height/jquery.matchHeight'
import 'what-input'
import 'plotly.js-dist'
import './front-page'
import './ie11'
import './header'
import './content'
import './selects'

objectFitImages()
/*
jQuery(document).on('gform_confirmation_loaded', function(event, formId){
    jQuery('body').addClass( 'gform-confirmation-displaying' )
})

setTimeout(function () {
    if( jQuery( '.splash__holder .splash--video' ).length > 0 )
        window['splash_video'].play()
}, 1000)


jQuery(window).ready(function(){
	setSliderBackgroundHeight();
});
jQuery( window ).resize(function() {
	setSliderBackgroundHeight();
});

function setSliderBackgroundHeight() {

	if(jQuery('#splash__background').length > 0){
		jQuery('#splash__background').height(jQuery('#fp-intro__right__image').offset().top + jQuery('#fp-intro__right__image').height())
	}
}

jQuery( '.gform_footer' ).on( 'click', function( e ) {
    jQuery( e.target ).closest('form').submit()
})
 */





//  if(jQuery(window).width() >= 1024){
//
//
//
// 	 const canvasHeight = document.querySelector('#canvas').offsetHeight;
// 	 console.log(canvasHeight)
//
// 	 const sliderHeight = document.querySelector('#content-slider').offsetHeight;
// 	 console.log(sliderHeight);
//
//  	const totalHeight = canvasHeight + sliderHeight;
//
// 	console.log(document.querySelector('#featured_sidebar').offsetHeight );
//
// 	document.querySelector('#featured_sidebar').offsetHeight = totalHeight;
//
// 	console.log(document.querySelector('#featured_sidebar') );
//
//
//  }
//
// jQuery(window).resize(function(){
//
// });
